import {IconButton, Menu, Popover} from "@mui/material";
import FullScreenOverlay from "../../../components/full-screen-overlay";
import PyqMockDropdownUI from "../../../features/mock-test-table/components/search-dropdown/PyqMockDropdownUI";
import SyllabusDropdown from "../../../features/problemset-table-v2/components/filter/SyllabusDropdown";
import {MaterialSymbol} from "react-material-symbols";
import {useRef} from "react";
import {STYLES} from "./STYLES";

export enum SearchButtonDropdownType {
  SYLLABUS,
  YEAR,
}
export type SearchButtonDropdownUseRefType = {
  closeDropdown: () => void;
  applyFilters: () => void;
};

interface SearchButtonDropdownMainProps {
  anchorRef: React.RefObject<HTMLButtonElement>;
  openState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  dropdownType: SearchButtonDropdownType;
}
export default function SearchButtonDropdownMain({
  anchorRef,
  openState: [isButtonDropdownOpen, setIsButtonDropdownOpen],
  dropdownType,
}: SearchButtonDropdownMainProps) {
  const dropdownRef = useRef<SearchButtonDropdownUseRefType>(null);

  const handleDropdownClose = () => {
    dropdownRef.current?.closeDropdown();
    setIsButtonDropdownOpen(false);
  };

  const handleApplyFilters = () => {
    dropdownRef.current?.applyFilters();
  };

  function DropdownContent() {
    switch (dropdownType) {
      case SearchButtonDropdownType.SYLLABUS:
        return (
          <SyllabusDropdown
            handleDropdownClose={handleDropdownClose}
            ref={dropdownRef}
          />
        );
      case SearchButtonDropdownType.YEAR:
        return <PyqMockDropdownUI handleDropdownClose={handleDropdownClose} />;
    }
  }

  const popoverProps = {
    anchorEl: anchorRef.current,
    anchorOrigin: {
      vertical: "bottom" as const,
      horizontal: "left" as const,
    },
    transformOrigin: {
      vertical: "top" as const,
      horizontal: "left" as const,
    },
  };

  return (
    <>
      <FullScreenOverlay
        open={isButtonDropdownOpen}
        onClick={handleDropdownClose}
      />
      <Popover
        open={isButtonDropdownOpen}
        {...popoverProps}
        onClose={handleDropdownClose}
        slotProps={{
          root: {sx: {mt: 1}},
          paper: {sx: STYLES.popoverPaperSlotProps},
        }}>
        <IconButton
          sx={STYLES.popoverCloseButton}
          onClick={handleDropdownClose}>
          <MaterialSymbol icon="close" size={20} weight={500} />
        </IconButton>
        <DropdownContent />
      </Popover>
    </>
  );
}
